import React from 'react';
import { ChevronDown } from 'lucide-react';

import { useGetAreas } from '~/entities/Guide/api/useGetAreas';
import { useRoleSearchFilter } from '~/entities/Requests/contexts/RoleSearchFilterContext';
import { useProfilePermissions } from '~/shared/hooks/useProfilePermissions';

import { Tag } from './Tag';

interface AccessSelectionTagProps {
  className?: string;
}

export function AccessSelectionTag({ className }: AccessSelectionTagProps) {
  const { isAdministrator } = useProfilePermissions();
  const { data: areas = [] } = useGetAreas();
  const { mode, areaId, setAreaFilter, setUserBasedMode, clearFilter } =
    useRoleSearchFilter();

  const [isOpen, setIsOpen] = React.useState(false);

  const selectedArea = areas.find(area => area.id === areaId);

  const label =
    mode === 'userBased'
      ? 'User Based'
      : selectedArea
      ? selectedArea.name
      : 'All areas';

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleSelectAll = () => {
    clearFilter();
    setIsOpen(false);
  };

  const handleSelectArea = (id: string) => {
    setAreaFilter(id);
    setIsOpen(false);
  };

  const handleSelectUserBased = () => {
    setUserBasedMode();
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block">
      <Tag
        text={label}
        className={`flex items-center gap-1 ${className ?? ''}`}
        onClick={handleToggle}
        icon={<ChevronDown className="w-3 h-3" />}
      />

      {isOpen && (
        <div className="absolute z-20 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg">
          <div className="max-h-64 overflow-y-auto">
            <button
              type="button"
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
              onClick={handleSelectAll}>
              All areas
            </button>

            {isAdministrator() && (
              <button
                type="button"
                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                onClick={handleSelectUserBased}>
                User Based
              </button>
            )}

            {areas.map(area => (
              <button
                key={area.id}
                type="button"
                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                onClick={() => handleSelectArea(area.id)}>
                {area.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
